import { useId, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { STATES_WITHOUT_EXCLUSION_LIST } from "@api/shared-runtime/state-exclusion-coverage";
import { pluralizeStates } from "./state-rows";

/** States that publish no Medicaid exclusion list are covered by the federal
 * screenings, so they get one line; each state's guidance link is on demand. */
export function StatesWithoutList() {
  const [open, setOpen] = useState(false);
  const listId = useId();
  const states = [...STATES_WITHOUT_EXCLUSION_LIST].sort((a, b) =>
    a.stateName.localeCompare(b.stateName),
  );
  const Chevron = open ? ChevronDown : ChevronRight;
  if (states.length === 0) {
    return null;
  }
  return (
    <div className="space-y-1 p-3 text-xs leading-5 text-muted-foreground">
      <p>
        <span className="font-medium text-foreground">
          {pluralizeStates(states.length)} publish no Medicaid exclusion list
        </span>{" "}
        ({states.map((state) => state.stateName).join(", ")}). Covered by the
        federal OIG and SAM screenings in this run.
      </p>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={listId}
        onClick={() => setOpen(!open)}
        className="flex cursor-pointer items-center gap-1 rounded-sm font-medium text-foreground hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary"
      >
        <Chevron className="size-3.5 shrink-0" aria-hidden />
        {open ? "Hide" : "Show"} state guidance links
      </button>
      {open && (
        <ul id={listId} className="flex flex-wrap gap-x-4 gap-y-1">
          {states.map((state) => (
            <li key={state.stateCode}>
              <a
                href={state.evidenceUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`State guidance for ${state.stateName}`}
                className="underline"
              >
                {state.stateName}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
